<template>
  <v-container
    class="error-page fill-height"
    tag="section"
  >
    <v-row
      class="text-center"
      justify="center"
    >
      <v-col cols="auto">
        <h1 class="title font-weight-black">
          404
        </h1>

        <div class="display-3 mb-5 mt-10">
          Nous ne connaissons pas la page que vous demandez...<br>
          Devrions-nous ?
          <v-icon
            right
            x-large
          >
            mdi-wrench
          </v-icon>
        </div>

        <v-btn
          depressed
          outlined
          to="/"
        >
          Retour à l'accueil
          <v-icon
            right
          >
            mdi-chevron-right
          </v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  /* Rend le composant accessible aux autres composants */
  export default {
    /* Nom du composant */
    name: 'PagesError',
  }
</script>

<style lang="sass">
  .error-page
    h1
      font-size: 12rem
</style>
